import React, { useState, useEffect } from "react";
import {
  FiBookOpen, FiSearch, FiX, FiMenu, FiSettings, FiBell,
  FiFileText, FiList, FiBook, FiZap, FiCompass, FiLogOut
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSideBar-Component/AdminSidebar";
import './AdminDashboard.css';
import SummaryCards from "./SummaryCards";
import StudentGrowthChart from './StudentGrowthChart';
import ExpandableCard from "./ExpandableCard";
import './ManageStudentSection.css';
import AdminActions from "./AdminActions";
import SectionHeading from "./Comman/SectionHeading";
import { HiAcademicCap } from "react-icons/hi";
import { motion } from 'framer-motion';
import { menuItems } from "../AdminSideBar-Component/SidebarMenuItems";
import api from '../../api';
import handleLogout from "./Comman/handleLogout";

function AdminDashboard() {
  const [notificationCount, setNotificationCount] = useState(3); // replace with dynamic fetch later

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    totalStudents: 0,
    activeStudents: 0,
    inactiveStudents: 0,
    activeExams: 0,
    inactiveExams: 0,
    vouchers: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    console.log("Auth Token from localStorage:", token);
  }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        // ✅ Fetch all students
        const studentsRes = await api.get('/users');
        //const students = studentsRes.data;
        const students = Array.isArray(studentsRes.data.data) ? studentsRes.data.data : studentsRes.data;

        // Count active/inactive students
        const activeStudents = students.filter(s => s.status === 1).length;
        const inactiveStudents = students.filter(s => s.status !== 1).length;

        // ✅ Fetch exams
        //const examsRes = await axios.get(`${API_URL}/api/exams`);
        const examsRes = await api.get('/exams');
        // const exams = examsRes.data;
        const exams = Array.isArray(examsRes.data.data) ? examsRes.data.data : examsRes.data;

        // Count active/inactive exams
        const activeExams = exams.filter(e => e.status === 1 || e.status === true).length;
        const inactiveExams = exams.filter(e => e.status === 0 || e.status === false).length;

        // ✅ Fetch vouchers
        //const vouchersRes = await axios.get(`${API_URL}/api/vouchers`);
        const vouchersRes = await api.get('/vouchers');

        setDashboardData({
          totalStudents: students.length,
          activeStudents,
          inactiveStudents,
          activeExams,
          inactiveExams,
          vouchers: vouchersRes.data.total || 0,
        });
      } catch (err) {
        console.error("❌ Failed to fetch dashboard data", err);
        setError("Failed to load dashboard data.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);


  return (
    <div className="dashboard-container">
      <header className="dashboard-header admin-header">
        <div
          className="menu-icon"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          title={sidebarOpen ? 'Close Menu' : 'Open Menu'}
        >
          {sidebarOpen ? (
            <FiX size={28} className="menu-toggle-icon close-icon" />
          ) : (
            <FiMenu size={28} className="menu-toggle-icon open-icon" />
          )}
        </div>

        <h2 className="admin-dashboard-title">
          <FiSettings className="gear-icon" />
          Admin Dashboard
        </h2>

        {/* code for that bell icon of notification */}
        <div className="header-icons">
          <div
            className="notification-wrapper"
            onClick={() => navigate("/admin-notifications")}
            title="Notifications"
          >
            <FiBell size={35} className="bell-icon" />
            {notificationCount > 0 && (
              <span className="notification-badge">{notificationCount}</span>
            )}
          </div>
          {/* Logout */}
          {/* <div
            className="logout-wrapper glassy"
            onClick={() => handleLogout(() => navigate("/admin-login"))}
            title="Logout"
          >
            <FiLogOut size={25} className="logout-icon" />
          </div> */}
          {/* Logout */}
          <div
            className="logout-wrapper glassy"
            onClick={handleLogout}  // updated to use fixed handleLogout
            title="Logout"
          >
            <FiLogOut size={25} className="logout-icon" />
          </div>

        </div>
      </header>
      {/* code for search bar*/}
      {/* <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by subject or exam..."
                    className="search-input"
                /> */}

      {/* search button code */}
      {/* <button className="search-button">
                    <FiSearch size={16} />
                    <span>Search</span>
                </button>
            </div> */}

      {/* here we start main content */}
      <main className="dashboard-main">
        <h2 className="welcome-heading" id="welcome-section">
          <HiAcademicCap className="welcome-icon" />
          Welcome to the Admin Dashboard
        </h2>


        {/* this is our summary section */}
        <SummaryCards data={dashboardData} id="summary-section" />

        {/* code for admin actions file calling */}
        <SectionHeading text="Quick Admin Actions"
          IconComponent={FiZap} color="#f1c40f"
        />
        <AdminActions id="chart-section" />

        {/* Sidebar menu items as dashboard cards */}


        {/* <div className="cards-container">
                   <motion.div
                    className="cards-wrapper"
                    initial="hidden"
                    animate="visible"
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.1
                            }
                        }
                    }}
                >
                    {menuItems.map((item, index) => (
                        <motion.div
                            key={item.label}
                            className="dashboard-card"
                            onClick={() => navigate(item.path)}
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0 }
                            }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.97 }}
                            transition={{ duration: 0.4, ease: "easeOut" }}
                        >
                            <motion.div
                                className="dashboard-card-icon"
                                initial={{ rotate: 0 }}
                                animate={{ rotate: [0, 360, 0] }} // rotate 0° → 360° → back to 0°
                                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                            >
                                {item.icon}
                            </motion.div>
                            <div className="dashboard-card-title">{item.label}</div>
                        </motion.div>
                    ))}
                </motion.div>
               </div> */}

        <div className="dashboard-cards-container">
          <SectionHeading text="Navigation Shortcuts"
            IconComponent={FiList} color="#f1c40f" />
          <motion.div
            className="cards-wrapper"
            initial="hidden"
            animate="visible"
            variants={{
              visible: {
                transition: { staggerChildren: 0.1 }
              }
            }}
          >
            {menuItems.map((item, index) => (
              <motion.div
                key={item.label}
                className="dashboard-card"
                onClick={() => navigate(item.path)}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 }
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <motion.div
                  className="dashboard-card-icon"
                  initial={{ rotate: 0 }}
                  animate={{ rotate: [0, 360, 0] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                >
                  {item.icon}
                </motion.div>
                <div className="dashboard-card-title">{item.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>




        {/* this is for studentgrowth chart    */}
        <StudentGrowthChart />


        {/* use that resuable component named expandablecard.js */}
        {/* <div className="cards-wrapper">
                    <ExpandableCard title="Total Exams" items={dummyExams} IconComponent={FiFileText} />
                    <ExpandableCard title="Total Subjects" items={dummySubjects} IconComponent={FiBookOpen} />
                    <ExpandableCard title="Total Topics"
                        items={dummyTopics} IconComponent={FiBook} />
                </div> */}
      </main>


      {/* You can conditionally render sidebar here */}
      {/* {sidebarOpen && (
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            )} */}
      {sidebarOpen && (
        <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      )}


    </div>
  );
}

export default AdminDashboard;